import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { closeModal } from "../modal/modal";
import { setIsLogin } from "./checkLoginSlice";
import { alert } from "../../../Utils/toast";
import { checkLoginActions } from "./checkLogin";
import { queryClient } from "../../store";
import { getCurrentLanguage } from "../../../Utils/sagaHelpers";
import Cookies from "js-cookie";

export type VerifyAuthGoogleTypes = {
  token: string;
};

export type AuthGoogleLoadAction = {
  type: string;
  payload: VerifyAuthGoogleTypes;
};

export type AuthGoogleData = {
  data: any;
};

const AuthGoogle = new ReduxFetchState<AuthGoogleData, VerifyAuthGoogleTypes, any>("authGoogle");

export function* watchAuthGoogle(action: AuthGoogleLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: AuthGoogleData = yield axios({
      headers: { "Content-Type": "multipart/form-data" },
      url: `/api/v1/users/auth/google?token=${action.payload?.token}`,
      method: "GET",
    });

    yield put(AuthGoogle.actions.loadSuccess(data));
    yield put(setIsLogin(true));
    queryClient.removeQueries({ queryKey: ["checkLogin", lang] });
    Cookies.remove("checkLogin", { domain: ".lamtakam.com" });
    setTimeout(() => {
      window.location.reload();
    }, 500);

    alert({ message: data?.data?.message, type: "success" });
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(AuthGoogle.actions.loadFailure(e.message));
  }
}

export function* authGoogleSagas() {
  yield takeEvery(AuthGoogle.actionTypes.load, watchAuthGoogle);
}

export function useAuthGoogle() {
  const { loading, data, ...authGoogleState } = useAppSelector((state) => state.authGoogle);
  const dispatch = useAppDispatch();

  const dispatchAuthGoogle = useCallback(
    (data: VerifyAuthGoogleTypes) => {
      dispatch(AuthGoogle.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...authGoogleState,
    dispatchAuthGoogle,
    authGoogleLoading: loading,
    authGoogleData: data,
  };
}

export const {
  actionTypes: authGoogleActionsTypes,
  actions: authGoogleActions,
  reducer: authGoogleReducer,
} = AuthGoogle;
